import { type ReactNode, useEffect, useRef } from "react";

import { useStartIdVerification } from "@/api/generated";
import { useGetUserProfile } from "@/api/queries/userProfile";
import PendingContent from "./PendingContent";

export default function StartDatabaseIdVerification({
  onContinue,
  loadingIndicator,
}: {
  onContinue: () => void;
  /** Shown instead of the spinner, and while advancing, for hosts that have their own loading state. */
  loadingIndicator?: ReactNode;
}) {
  const { mutate: startIdVerification } = useStartIdVerification();
  const { data: userProfile, isLoading } = useGetUserProfile();
  const hasContinuedRef = useRef(false);

  useEffect(() => {
    if (isLoading || hasContinuedRef.current) return;

    if (!userProfile?.idVerification) {
      startIdVerification();
    }
    hasContinuedRef.current = true;
    onContinue();
  }, [isLoading, userProfile?.idVerification, startIdVerification, onContinue]);

  if (loadingIndicator) return loadingIndicator;
  if (isLoading) return <PendingContent />;

  return null;
}
